<!--
 * @Author: fengxiaojing
 * @LastEditTime: 2025-05-27 18:12:54
 * @Description: 材质编辑
 * @LastEditors: heqing heqing@wiz.top
-->
<template>
  <div
    class="position-absolute left-container"
    :style="{ height: height, top: top, width: '388px!important', overflow: `visible !important` }"
  >
    <el-row
      type="flex"
      align="middle"
      class="card-title text-hex-fff text-24px h-52px w-full bg-no-repeat flex items-center pt-10px px-10px"
    >
      <el-col :span="18" class="fz-14 m-b-5px">材质编辑</el-col>
      <el-col :span="1" :offset="5">
        <span class="iconfont icon-line-close" @click="closeComponents"></span>
      </el-col>
    </el-row>
    <!-- 模型选择树 -->
    <modelCheckTree
      class="modelCheckTree"
      @setCheckedNode="getCheckedNode"
      @multiItems="multiSelected"
      :multiSelectedItems="multiSelectedItems"
      :disabled="modelCheckTreeDisabled"
      :modelName="modelName"
      :currentNodeItemF="currentSelectedModelItem"
      :player="player"
      :top="top"
    ></modelCheckTree>
    <!-- 模型编辑框 -->
    <div class="texture position-absolute" v-drag>
      <!-- 表头 -->
      <div>
        <el-row type="flex" align="middle">
          <el-col :span="18" class="fz-14 m-b-5px text-color-white">材质编辑</el-col>
          <el-col :span="1" :offset="5">
            <span class="iconfont icon-close text-color-white" @click="closeComponents"></span>
          </el-col>
        </el-row>
      </div>
      <!-- 材质编辑 -->
      <div class="fz-12 h-full texture_edit">
        <el-row :gutter="20" class="flex texture_row">
          <el-col :span="6" :offset="0" class="text-color-white">对象选择</el-col>
          <el-col :span="18" :offset="0">
            <el-select
              v-model="textureFrom.objSelect"
              popper-class="document_select-popper"
              value-key
              size="small"
              clearable
              filterable
              :disabled="disableByTexture"
              @change="selectChange"
            >
              <el-option
                v-for="item in typeList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-col>
        </el-row>
        <el-row :gutter="20" class="flex m-t-2px">
          <el-col :span="6" :offset="0" class="text-color-white">模型颜色</el-col>
          <el-col :span="3" :offset="0">
            <el-color-picker
              v-model="textureFrom.modelColor"
              :disabled="disableByTexture"
              popper-class="document_color_select-popper"
              @change="handleChange('modelColor')"
              :predefine="predefineColors"
            ></el-color-picker>
          </el-col>
          <el-col :span="12" :offset="0">
            <el-input
              :disabled="disableByTexture"
              v-model="textureFrom.modelColor"
              placeholder
              size="mini"
            ></el-input>
          </el-col>
        </el-row>
        <el-row :gutter="20" class="roughness flex">
          <el-col :span="7" :offset="0" class="text-color-white">材质透明度</el-col>
          <el-col :span="8" :offset="0">
            <el-slider
              :disabled="disableByTexture"
              v-model="textureFrom.vague"
              @change="handleChange('vague')"
              :step="1"
              :max="255"
            ></el-slider>
          </el-col>
          <el-col :span="8" :offset="0">
            <el-input-number
              :disabled="disableByTexture"
              v-model="textureFrom.vague"
              controls-position="right"
              @change="handleChange('vague')"
              :min="0"
              :max="255"
              size="mini"
              :step="1"
            ></el-input-number>
          </el-col>
        </el-row>
        <el-row :gutter="20" class="flex">
          <el-col :span="7" :offset="0" class="text-color-white">粗糙度</el-col>
          <el-col :span="8" :offset="0">
            <el-slider
              :disabled="disableByTexture"
              v-model="textureFrom.roughness"
              @change="handleChange('roughness')"
              :step="0.1"
              :max="1"
            ></el-slider>
          </el-col>
          <el-col :span="8" :offset="0">
            <el-input-number
              :disabled="disableByTexture"
              v-model="textureFrom.roughness"
              controls-position="right"
              @change="handleChange('roughness')"
              :min="0"
              :max="1"
              size="mini"
              :step="0.1"
            ></el-input-number>
          </el-col>
        </el-row>
        <el-row :gutter="20" class="flex">
          <el-col :span="7" :offset="0" class="text-color-white">金属度</el-col>
          <el-col :span="8" :offset="0">
            <el-slider
              :disabled="disableByTexture"
              v-model="textureFrom.metalness"
              @change="handleChange('metalness')"
              :max="1"
              :step="0.1"
            ></el-slider>
          </el-col>
          <el-col :span="8" :offset="0">
            <el-input-number
              :disabled="disableByTexture"
              v-model="textureFrom.metalness"
              controls-position="right"
              @change="handleChange('metalness')"
              :min="0"
              :max="1"
              :step="0.1"
              size="mini"
            ></el-input-number>
          </el-col>
        </el-row>
        <el-row :gutter="20" class="flex m-t-5px">
          <el-col :span="4">
            <el-button
              :disabled="disableByTexture"
              class="button-color"
              size="mini"
              type="primary"
              @click="resetChoose"
              >重新选择</el-button
            >
          </el-col>
          <el-col :span="4" :offset="10">
            <el-button
              :disabled="disableByTexture"
              class="button-color"
              size="mini"
              type="primary"
              @click="saveTexture"
              >保存</el-button
            >
          </el-col>
          <el-col :span="4" :offset="1">
            <el-button :disabled="disableByTexture" type="defalut" size="mini" @click="resetTexture"
              >重置</el-button
            >
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import ApiMixinSystem from '@/assets/js/api/systemParams'
import modelCheckTree from './modelCheckTree'

export default {
  name: 'EditTexture',
  components: { modelCheckTree },
  mixins: [ApiMixinSystem],
  computed: {
    systemParams() {
      return this.$store.getters.systemParams || []
    },
  },
  props: {
    player: {
      type: Object,
    },
    height: {
      type: String,
      default: '50rem',
    },
    top: {
      type: String,
      default: '6.6rem',
    },
    modelName: {
      type: String,
      default: '',
    },
    currentItem: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      modelCheckTreeDisabled: false,
      typeList: [
        {
          lable: '1',
          value: '当前对象',
        },
        {
          lable: '2',
          value: '当前材质',
        },
      ],
      textureFrom: {
        objSelect: '当前对象',
        modelColor: '',
        roughness: 0,
        metalness: 0,
        highlight: 0,
        vague: 0,
      },
      currentTexture: {}, // 当前对象
      newTexture: {}, // 当前材质
      predefineColors: [],
      predefineColorsParams: [],
      timer: null,
      disableByTexture: true, // 材质编辑所有输入框 按钮的状态
      currentNodeInfo: [], // 当前选中节点信息
      isMultiSelected: false, // 是否多选状态
      multiSelectedItems: [], // 多选模型集合
      currentSelectedModelItem: 0, // 当前选中模型item
    }
  },
  watch: {
    currentItem(val, oldVal) {
      if (val) {
        this.$nextTick(async () => {
          if (this.isMultiSelected) {
            this.multiSelectedItems = await this.player.Native.ModelTree.getMultiSelectedItems()
          }
          this.currentSelectedModelItem = val
          if (oldVal && !this.isMultiSelected) {
            this.player.Native.ModelTree.restoreItemMaterial([oldVal])
          }
        })
      }
    },
  },
  methods: {
    closeComponents() {
      this.$emit('closeComponents', 'EditTexture')
    },
    // 选择模式切换
    async multiSelected(bool) {
      this.isMultiSelected = bool
      const toolName = bool ? 'system.ToolMultiSelect' : 'system.Pickup'
      this.player.Native.Tools.setCurrentTool(toolName)
    },
    /**
     * @description: 获取当前选中的节点
     * @param {Array} data
     * @return {*}
     */

    getCheckedNode(data) {
      this.currentNodeInfo = _.map(data, 'item')
      this.disableByTexture = false
      this.modelCheckTreeDisabled = true
      this.setTextureData()
    },
    /**
     * @description:对象选择变化
     * @param {*}
     * @return {*}
     */

    selectChange(row) {
      if (row === '当前对象') {
        this.textureFrom = { ...this.textureFrom, ...this.currentTexture }
      } else {
        this.textureFrom = { ...this.textureFrom, ...this.newTexture }
      }
      if (this.isMultiSelected) {
        this.player.Native.Tools.setCurrentTool('system.Browse')
        this.player.Native.ModelTree.setSelectItemNoEvent(0)
      }
      this.handleChange()
    },
    updateSystemParams() {
      const params = [
        {
          id: this.predefineColorsParams.id || null,
          parameterValue: this.predefineColors.join(','),
          remark: this.predefineColorsParams.remark || null,
          parentId: this.predefineColorsParams.parentId || null,
          parameterType: this.predefineColorsParams.parameterType,
          parameterCode: this.predefineColorsParams.parameterCode || null,
          parameterName: this.predefineColorsParams.parameterName || null,
        },
      ]
      this.apiSystemParams({
        method: 'updateSystemParams',
        params,
      }).then((res) => {
        if (res.success) {
          this.updateCommonSystemList()
        }
      })
    },
    async updateCommonSystemList() {
      const systemParamsRes = await this.apiSystemParams({
        method: 'getSystem',
        params: {
          dataPage: {
            pageSize: 999,
          },
        },
      })
      if (systemParamsRes && systemParamsRes.success) {
        this.$store.dispatch('systemParams', systemParamsRes.dataList)
      }
    },
    /**
     * @description: 通知模型更新材质
     * @param {*}
     * @return {*}
     */

    handleChange(val) {
      if (
        val === 'modelColor' &&
        this.predefineColors.indexOf(this.textureFrom.modelColor) === -1
      ) {
        // 颜色变化，且系统参数中不含有该颜色
        this.predefineColors.unshift(this.textureFrom.modelColor)
        this.predefineColors =
          this.predefineColors.length > 10
            ? this.predefineColors.slice(0, 20)
            : this.predefineColors
      }
      if (this.timer) {
        clearTimeout(this.timer)
      }
      if (this.timer) {
        clearTimeout(this.timer)
      }
      this.timer = setTimeout(async () => {
        // 更新材质
        const color = this.hex2rgb(this.textureFrom.modelColor)
        color.a = Number((this.textureFrom.vague / 255).toFixed(4))
        const query = {
          items: this.currentNodeInfo,
          editMode: this.textureFrom.objSelect === '当前对象' ? 1 : 2,
          matParam: {
            name: this.textureFrom.name,
            matIndex: this.textureFrom.matIndex,
            color,
            metalness: this.textureFrom.metalness,
            roughness: this.textureFrom.roughness,
          },
        }
        await this.player.Native.ModelTree.updateItemMaterial(
          query.items,
          query.editMode,
          query.matParam
        )
      }, 500)
    },
    /**
     * @description: 重新选择
     * @param {*}
     * @return {*}
     */

    async resetChoose() {
      this.multiSelected(this.isMultiSelected)
      await this.player.Native.ModelTree.restoreItemMaterial(this.currentNodeInfo)
      this.textureFrom = this.$options.data().textureFrom
      this.disableByTexture = true
      this.modelCheckTreeDisabled = false
    },
    /**
     * @description: 保存材质
     * @param {*}
     * @return {*}
     */

    async saveTexture() {
      const res = await this.player.Native.Model.saveItemMaterial(this.modelName)
      if (res) {
        this.$message.success('保存材质成功！')
        // 加载模型材质文件
        this.player.Native.Model.loadItemMaterial(this.modelName)
      } else {
        this.$message.warning('保存材质失败！')
        await this.player.Native.ModelTree.restoreItemMaterial(this.currentNodeInfo)
      }

      console.log(res, this.modelName, 'aaaaaaaaaaaa')
      this.multiSelected(this.isMultiSelected)
      this.disableByTexture = true
      this.modelCheckTreeDisabled = false
    },
    /**
     * @description: 重置材质
     * @param {*}
     * @return {*}
     */

    resetTexture() {
      this.textureFrom = this.$options.data().textureFrom
      this.selectChange(this.textureFrom.objSelect)
    },
    async setTextureData() {
      this.textureFrom = this.$options.data().textureFrom
      this.typeList = this.$options.data().typeList
      // 获取当前节点的材质
      let currentNodeTexture = await PlayerUtils.call(
        this.player.Native.ModelTree.fetchItemMaterial,
        this.currentNodeInfo,
        1 + 2
      )
      currentNodeTexture = _.map(currentNodeTexture, (res) => {
        const modelColor = this.rgb2hex(
          `rgb(${res.color.r * 255},${res.color.g * 255},${res.color.b * 255})`
        )
        return {
          matIndex: res.matIndex,
          name: res.name,
          modelColor,
          vague: res.color.a * 255,
          roughness: res.roughness,
          metalness: res.metalness,
        }
      })
      if (currentNodeTexture[1].matIndex >> 1 === -1) {
        this.typeList = [
          {
            lable: '1',
            value: '当前对象',
          },
        ]
      }
      this.currentTexture = currentNodeTexture[0]
      this.newTexture = currentNodeTexture[1]
      this.selectChange(this.textureFrom.objSelect)
    },
    /**
     * @description: rgb与16进制转化
     * @param {*} rgb
     * @return {*}
     */

    rgb2hex(rgb) {
      const reg = /^((rgb|RGB)\(\d+),\s*(\d+),\s*(\d+)\)$/
      if (!reg.test(rgb)) return ''
      const rgbArr = rgb.slice(4, -1).split(',')
      const resultArr = _.map(rgbArr, (item) => {
        if (+item > 16) return (+item).toString(16)
        return `0${(+item).toString(16)}`
      })
      return `#${resultArr.join('')}`
    },
    /**
     * @description: hex转化成rgb
     * @param {*} hex
     * @return {*}
     */

    hex2rgb(hex) {
      const result = {}
      result.r = Number((parseInt(hex.substring(1, 3), 16) / 255).toFixed(4))
      result.g = Number((parseInt(hex.substring(3, 5), 16) / 255).toFixed(4))
      result.b = Number((parseInt(hex.substring(5), 16) / 255).toFixed(4))
      return result
    },
  },
  created() {
    this.predefineColorsParams =
      _.find(this.systemParams, { parameterCode: 'PredefineColors' }) || ''
    if (this.predefineColorsParams && this.predefineColorsParams.parameterValue) {
      this.predefineColors = this.predefineColorsParams.parameterValue.split(',')
    } else {
      this.predefineColors = []
    }
  },
  async beforeDestroy() {
    // 更新系统参数 vuex
    this.updateSystemParams()
    if (!_.isEmpty(this.currentNodeInfo)) {
      await this.player.Native.ModelTree.restoreItemMaterial(this.currentNodeInfo)
    }
  },
}
</script>
<style lang="scss">

@import '../css/select.scss';
.model-doc-preview .el-input.is-disabled input.el-input__inner {
  background-color: rgba(24, 41, 72, 0.5) !important;
}

</style>
<style lang="scss" scoped>

@import '../css/component.scss';
.modelCheckTree {
  height: calc(100% - 50px) !important;
  left: 0px !important;
  background-color: #ffffff00 !important;
}
.texture {
  width: 368px;
  left: 413px;
  padding: 10px;
  height: 18rem;
  top: 66px;
  z-index: 1000;
  background-color: #1b4555 !important;
  &_edit {
    padding: 10px !important;
    height: calc(100% - 25px);
    background-color: #1b4555 !important;
    border-radius: 2px;
  }
}
/deep/.el-row {
  align-items: center;
}
/deep/.el-input-number--mini {
  width: 100px;
}
.roughness {
  /deep/.el-slider__runway {
    background: linear-gradient(90deg, hsla(0, 0%, 100%, 0) 0, #fff);
  }
}
/deep/.el-input-number.is-controls-right .el-input-number__decrease {
  border-left: none;
}
/deep/.el-input-number.is-controls-right .el-input-number__increase {
  border-bottom: none;
}
/deep/ .el-color-picker {
  height: 28px;
  line-height: 28px;
}
/deep/.el-color-picker__trigger {
  height: 28px;
  width: 28px;
}
/deep/.el-color-picker__mask {
  height: 26px;
  width: 26px;
}
/deep/ .el-input-group__append button.el-button {
  padding-left: 15px;
  padding-right: 15px;
  background: transparent !important;
  color: white !important;
  padding-top: 0px;
  padding-bottom: 0px;
  margin: 0px !important;
}
/deep/ .el-input-group__append {
  padding: 0;
}
/deep/ .el-checkbox {
  margin-bottom: 0 !important;
}
.text-color-white {
  color: white;
}
.position-absolute {
  position: absolute;
}
.fz-12 {
  font-size: 12px;
}
.fz-14 {
  font-size: 14px;
}
.m-t-2px {
  margin-top: 2px;
}
.m-t-10px {
  margin-top: 10px;
}
.m-t-5px {
  margin-top: 5px;
}

</style>
